// The thresholds the tagger, the API and the site all say, and nothing else:
// no imports and no SQL, so the browser loads only these few numbers rather
// than tags.ts, ranks.ts and updates.ts, which re-export them for the
// Workers.

// A 24h change only counts from at least this many players a day earlier
// (the trend tag's rising and falling; GET /api/trending lists the rises):
// from a small base a few dozen players is a big percentage, and the list
// would be all noise.
export const CHANGE_MIN_PLAYERS = 1000;

// How many games each state of a movers tag goes on: the ones showing it
// most. Also GET /api/trending's largest limit, as it lists trend's rising.
export const MOVERS_PER_TAG = 25;

// peak_share: near is a game at this share of its peak or more; far, the
// games furthest below theirs. Both only for games tracked at least
// PEAK_MIN_DAYS, so a new game isn't trivially at its peak, and far only for
// a peak of CHANGE_MIN_PLAYERS or more, so a tiny game dipping
// from 40 players to 3 doesn't top it. Here, not in ../tagger alone, as the
// site's tag pages say them too.
export const NEAR_PEAK_SHARE = 0.9;
export const PEAK_MIN_DAYS = 30;

// update_bump: a major or regular update posted in the last
// UPDATE_BUMP_DAYS whole days (so its full week after stays tagged for a week
// more), from a week before of CHANGE_MIN_PLAYERS or more, whose
// players rose UPDATE_BUMP_MIN or more. Here, as the site's tag page says them
// too.
export const UPDATE_BUMP_DAYS = 14;
export const UPDATE_BUMP_MIN = 0.1;

// How many games update_bump goes on: its own, not MOVERS_PER_TAG, though the
// same today.
export const UPDATE_BUMP_GAMES = 25;

// sale_bump: a sale (a price_changes row at a discount of SALE_MIN_DISCOUNT
// percent or more, straight after a full-price one) started in the last
// SALE_BUMP_DAYS whole days (so its full week after stays tagged for a week
// more), from a week before of CHANGE_MIN_PLAYERS or more, whose players rose
// SALE_BUMP_MIN or more. The discount floor leaves out the 5% price nudges
// that aren't sales. Here, as the site's tag page says them too.
export const SALE_BUMP_DAYS = 14;
export const SALE_BUMP_MIN = 0.1;
export const SALE_MIN_DISCOUNT = 10;

// How many games sale_bump goes on: its own, though the same as
// UPDATE_BUMP_GAMES today.
export const SALE_BUMP_GAMES = 25;

// new_release: up to NEW_RELEASE_GAMES of the most played ranked games
// released in the last NEW_RELEASE_DAYS days (tracked_apps.release_date).
// Here, as the site's tag page says them too.
export const NEW_RELEASE_DAYS = 30;
export const NEW_RELEASE_GAMES = 25;

// The kinds the game page's impact card weighs, and update_bump with it:
// small updates are patch notes. game.ts passes it on as DEFAULT_UPDATE_KINDS.
export const IMPACT_KINDS: readonly string[] = ["major", "regular"];
